import { Component, OnInit, OnDestroy } from '@angular/core';
import { UpdateService } from '../../services/update.service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { IconComponent } from '../../icon/icon.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-update-notification',
  templateUrl: './update-notification.component.html',
  styleUrls: ['./update-notification.component.scss'],
  standalone: true,
  imports: [CommonModule, MatButtonModule, IconComponent]
})
export class UpdateNotificationComponent implements OnInit, OnDestroy {
  showNotification = false;
  private subscription: Subscription | null = null;

  constructor(private updateService: UpdateService) {}

  ngOnInit(): void {
    this.subscription = this.updateService.updateAvailable.subscribe(() => {
      this.showNotification = true;
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }

  applyUpdate(): void {
    this.updateService.applyUpdate();
  }

  dismiss(): void {
    this.showNotification = false;
  }
}
